export enum DropdownMenuType {
  SelectableList = 'SelectableList',
  DateRange = 'DateRange'
}
